export default "__VITE_ASSET__DFZPn49h__"